import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProfileService from "../../services/profile.service";

/* =========================================================
   GET PROFILE
========================================================= */

export const getProfile = createAsyncThunk(
  "profile/getProfile",

  async (params, thunkAPI) => {
    try {
      const response =
        await ProfileService.getProfile(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch profile"
      );
    }
  }
);

/* =========================================================
   GET DASHBOARD SUMMARY
========================================================= */

export const getDashboardSummary = createAsyncThunk(
  "profile/getDashboardSummary",

  async (params, thunkAPI) => {
    try {
      const response =
        await ProfileService.getDashboardSummary(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch dashboard summary"
      );
    }
  }
);

/* =========================================================
   GET JOINING PAYMENT LIST
========================================================= */

export const getJoiningPaymentList = createAsyncThunk(
  "profile/getJoiningPaymentList",

  async (params = {}, thunkAPI) => {
    try {
      const response =
        await ProfileService.getJoiningPaymentList(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch joining payments"
      );
    }
  }
);


export const getSelfActivateWallets = createAsyncThunk(
  "profile/getSelfActivateWallets",

  async (params = {}, thunkAPI) => {
    try {
      const response =
        await ProfileService.getSelfActivateWallets(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch self-activate wallets"
      );
    }
  }
);

export const getSelfActivationTransferTransactions = createAsyncThunk(
  "profile/getSelfActivationTransferTransactions",

  async (params = {}, thunkAPI) => {
    try {
      const response =
        await ProfileService.getSelfActivationTransferTransactions(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch self-activate wallets"
      );
    }
  }
);

/* =========================================================
   GET USERS
========================================================= */

export const getUsers = createAsyncThunk(
  "profile/getUsers",

  async (params = {}, thunkAPI) => {
    try {
      const response =
        await ProfileService.getUsers(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch users"
      );
    }
  }
);

/* =========================================================
   EDIT USER PROFILE
========================================================= */

export const edituserprofile = createAsyncThunk(
  "profile/edituserprofile",

  async (params, thunkAPI) => {
    try {
      const response =
        await ProfileService.edituserprofile(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to update user profile"
      );
    }
  }
);


export const transferSelfActivationAmountToCompanyWallet = createAsyncThunk(
  "profile/transferSelfActivationAmountToCompanyWallet",

  async (params, thunkAPI) => {
    try {
      const response =
        await ProfileService.transferSelfActivationAmountToCompanyWallet(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to transfer self activation amount to company wallet"
      );
    }
  }
);


/* =========================================================
   CHANGE PASSWORD
========================================================= */

export const changePassword = createAsyncThunk(
  "profile/changePassword",

  async (params, thunkAPI) => {
    try {
      const response =
        await ProfileService.changePassword(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to change password."
      );
    }
  }
);

/* =========================================================
   GET QR
========================================================= */

export const getQr = createAsyncThunk(
  "profile/getQr",

  async (params, thunkAPI) => {
    try {
      const response =
        await ProfileService.getQr(params);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch QR"
      );
    }
  }
);

/* =========================================================
   EDIT QR
========================================================= */

export const editQr = createAsyncThunk(
  "profile/editQr",

  async (payload, thunkAPI) => {
    try {
      const response =
        await ProfileService.editQr(payload);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to update QR"
      );
    }
  }
);

/* =========================================================
   APPROVE / REJECT JOINING PAYMENT
========================================================= */

export const approveRejectJoiningPayment =
  createAsyncThunk(
    "profile/approveRejectJoiningPayment",

    async (payload, thunkAPI) => {
      try {
        const response =
          await ProfileService.approveRejectJoiningPayment(
            payload
          );

        return response.data;

      } catch (error) {
        return thunkAPI.rejectWithValue(
          error.response?.data?.message ||
          error.response?.data?.error?.message ||
          error.message ||
          "Failed to update payment"
        );
      }
    }
  );

/* =========================================================
   UPDATE PROFILE
========================================================= */

export const updateProfile = createAsyncThunk(
  "profile/updateProfile",

  async (payload, thunkAPI) => {
    try {
      const response =
        await ProfileService.editProfile(payload);

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to update profile"
      );
    }
  }
);

/* =========================================================
   INITIAL STATE
========================================================= */

const initialState = {
  loading: false,

  error: null,

  profilelist: {},

  dashboardSummary: {},

  getDashboardSummaryLoading: false,

  /* =========================
     USERS
  ========================= */

  users: [],

  usersLoading: false,

  usersCount: 0,

  usersPagination: {
    totalUsers: 0,
    currentPage: 1,
    limit: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  /* =========================
     DIRECT REFERRALS
  ========================= */

  directReferrals: [],

  directReferralsLoading: false,

  directReferralsCount: 0,

  /* =========================
     JOINING PAYMENTS
  ========================= */

  joiningPaymentList: [],

  joiningPaymentListLoading: false,

  joiningPaymentCount: 0,

  joiningPaymentPagination: {
    total: 0,
    currentPage: 1,
    limit: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  joiningPaymentActionLoading: false,

  joiningPaymentActionSuccess: false,

  /* =========================
     QR
  ========================= */

  qr: null,

  qrLoading: false,

  qrUpdateLoading: false,

  /* =========================
     PROFILE UPDATE
  ========================= */

  updateSuccess: false,

  /* =========================
     CHANGE PASSWORD
  ========================= */

  changePasswordLoading: false,

  changePasswordSuccess: false,

  changePasswordError: null,

  /* =========================
   SELF ACTIVATE WALLETS
========================= */
  selfActivateWallets: [],
  selfActivateWalletsLoading: false,
  selfActivateWalletsCount: 0,
  selfActivateWalletsPagination: {
    total: 0,
    currentPage: 1,
    limit: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  /* =========================
     EDIT USER PROFILE
  ========================= */
  editUserProfileLoading: false,
  editUserProfileSuccess: false,
  editUserProfileError: null,
  selfActivateWalletsTotalAmountAvailable: 0,
};

/* =========================================================
   SLICE
========================================================= */

const profileSlice = createSlice({

  name: "profile",

  initialState,

  reducers: {

    /* =========================
       RESET PROFILE UPDATE
    ========================= */

    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },

    /* =========================
       RESET JOINING PAYMENT
    ========================= */

    resetJoiningPaymentAction: (state) => {
      state.joiningPaymentActionSuccess = false;
    },

    /* =========================
       CLEAR PROFILE ERROR
    ========================= */

    clearProfileError: (state) => {
      state.error = null;
    },

    /* =========================
       RESET CHANGE PASSWORD
    ========================= */

    resetChangePassword: (state) => {

      state.changePasswordLoading = false;

      state.changePasswordSuccess = false;

      state.changePasswordError = null;
    },
  },

  /* =========================================================
     EXTRA REDUCERS
  ========================================================= */

  extraReducers: (builder) => {

    /* =====================================================
       GET PROFILE
    ===================================================== */

    builder

      .addCase(
        getProfile.pending,
        (state) => {

          state.loading = true;

          state.error = null;
        }
      )

      .addCase(
        getProfile.fulfilled,
        (state, action) => {

          state.loading = false;

          state.error = null;

          state.profilelist =
            action.payload?.data || {};
        }
      )

      .addCase(
        getProfile.rejected,
        (state, action) => {

          state.loading = false;

          state.error =
            action.payload ||
            "Failed to fetch profile";
        }
      );

    /* =====================================================
       DASHBOARD SUMMARY
    ===================================================== */

    /* =====================================================
   GET SELF ACTIVATE WALLETS
===================================================== */

    builder
      .addCase(getSelfActivateWallets.pending, (state) => {
        state.selfActivateWalletsLoading = true;
        state.error = null;
      })

      .addCase(getSelfActivateWallets.fulfilled, (state, action) => {
        state.selfActivateWalletsLoading = false;
        state.error = null;

        const data = action.payload?.data || {};

        state.selfActivateWallets = Array.isArray(data.selfActivateWallets)
          ? data.selfActivateWallets
          : [];

        state.selfActivateWalletsCount =
          Number(data.totalSuccessfulRecords) || 0;
        state.selfActivateWalletsTotalAmountAvailable =
          Number(data.totalAmountAvailable) || 0;

        state.selfActivateWalletsPagination = {
          total: Number(data.pagination?.total) || 0,
          currentPage: Number(data.pagination?.currentPage) || 1,
          limit: Number(data.pagination?.limit) || 10,
          totalPages: Number(data.pagination?.totalPages) || 0,
          hasNextPage: data.pagination?.hasNextPage ?? false,
          hasPreviousPage: data.pagination?.hasPreviousPage ?? false,
        };
      })
      .addCase(getSelfActivateWallets.rejected, (state, action) => {
        state.selfActivateWalletsLoading = false;
        state.error =
          action.payload || "Failed to fetch self-activate wallets";
      });

    /* =====================================================
       EDIT USER PROFILE
    ===================================================== */

    builder
      .addCase(edituserprofile.pending, (state) => {
        state.editUserProfileLoading = true;
        state.editUserProfileSuccess = false;
        state.editUserProfileError = null;
      })
      .addCase(edituserprofile.fulfilled, (state, action) => {
        state.editUserProfileLoading = false;
        state.editUserProfileSuccess = true;
        state.editUserProfileError = null;

        const updatedProfile =
          action.payload?.data?.data ||
          action.payload?.data ||
          {};

        state.profilelist = {
          ...state.profilelist,
          ...updatedProfile,
        };
      })
      .addCase(edituserprofile.rejected, (state, action) => {
        state.editUserProfileLoading = false;
        state.editUserProfileSuccess = false;
        state.editUserProfileError =
          action.payload || "Failed to update user profile";
      });

    builder

      .addCase(
        getDashboardSummary.pending,
        (state) => {

          state.getDashboardSummaryLoading = true;

          state.error = null;
        }
      )

      .addCase(
        getDashboardSummary.fulfilled,
        (state, action) => {

          state.getDashboardSummaryLoading = false;

          state.error = null;

          state.dashboardSummary =
            action.payload?.data || {};
        }
      )

      .addCase(
        getDashboardSummary.rejected,
        (state, action) => {

          state.getDashboardSummaryLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch dashboard summary";
        }
      );

    /* =====================================================
       JOINING PAYMENT LIST
    ===================================================== */

    builder

      .addCase(
        getJoiningPaymentList.pending,
        (state) => {

          state.joiningPaymentListLoading = true;

          state.error = null;
        }
      )

      .addCase(
        getJoiningPaymentList.fulfilled,
        (state, action) => {

          state.joiningPaymentListLoading = false;

          state.error = null;

          const response =
            action.payload || {};

          const data =
            response.data || {};

          const payments =
            Array.isArray(data.payments)
              ? data.payments
              : [];

          const pagination =
            data.pagination || {};

          state.joiningPaymentList =
            payments;

          state.joiningPaymentPagination = {

            total:
              Number(
                pagination.total
              ) || payments.length,

            currentPage:
              Number(
                pagination.currentPage
              ) || 1,

            limit:
              Number(
                pagination.limit
              ) || 10,

            totalPages:
              Number(
                pagination.totalPages
              ) ||
              (
                Number(
                  pagination.total
                ) > 0
                  ? Math.ceil(
                    Number(
                      pagination.total
                    ) /
                    (
                      Number(
                        pagination.limit
                      ) || 10
                    )
                  )
                  : 0
              ),

            hasNextPage:
              pagination.hasNextPage ??
              false,

            hasPreviousPage:
              pagination.hasPreviousPage ??
              false,
          };

          state.joiningPaymentCount =
            Number(
              pagination.total
            ) || payments.length;
        }
      )

      .addCase(
        getJoiningPaymentList.rejected,
        (state, action) => {

          state.joiningPaymentListLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch joining payments";

          state.joiningPaymentList = [];

          state.joiningPaymentCount = 0;

          state.joiningPaymentPagination = {

            total: 0,

            currentPage: 1,

            limit: 10,

            totalPages: 0,

            hasNextPage: false,

            hasPreviousPage: false,
          };
        }
      );

    /* =====================================================
       APPROVE / REJECT JOINING PAYMENT
    ===================================================== */

    builder

      .addCase(
        approveRejectJoiningPayment.pending,
        (state) => {

          state.joiningPaymentActionLoading = true;

          state.joiningPaymentActionSuccess = false;

          state.error = null;
        }
      )

      .addCase(
        approveRejectJoiningPayment.fulfilled,
        (state, action) => {

          state.joiningPaymentActionLoading = false;

          state.joiningPaymentActionSuccess = true;

          state.error = null;

          const updatedPayment =
            action.payload?.data?.payment ||
            action.payload?.data ||
            null;

          if (updatedPayment?._id) {

            state.joiningPaymentList =
              state.joiningPaymentList.map(
                (item) =>
                  item._id ===
                    updatedPayment._id
                    ? {
                      ...item,
                      ...updatedPayment,
                    }
                    : item
              );
          }
        }
      )

      .addCase(
        approveRejectJoiningPayment.rejected,
        (state, action) => {

          state.joiningPaymentActionLoading = false;

          state.joiningPaymentActionSuccess = false;

          state.error =
            action.payload ||
            "Failed to update payment";
        }
      );

    /* =====================================================
       GET USERS
    ===================================================== */

    builder

      .addCase(
        getUsers.pending,
        (state) => {

          state.usersLoading = true;

          state.error = null;
        }
      )

      .addCase(
        getUsers.fulfilled,
        (state, action) => {

          state.usersLoading = false;

          state.error = null;

          const response =
            action.payload || {};

          const data =
            response.data || {};

          const users =
            Array.isArray(data.users)
              ? data.users
              : [];

          const pagination =
            data.pagination || {};

          state.users =
            users;

          state.usersPagination = {

            totalUsers:
              Number(
                pagination.totalUsers
              ) || users.length,

            currentPage:
              Number(
                pagination.currentPage
              ) || 1,

            limit:
              Number(
                pagination.limit
              ) || 10,

            totalPages:
              Number(
                pagination.totalPages
              ) ||
              (
                Number(
                  pagination.totalUsers
                ) > 0
                  ? Math.ceil(
                    Number(
                      pagination.totalUsers
                    ) /
                    (
                      Number(
                        pagination.limit
                      ) || 10
                    )
                  )
                  : 0
              ),

            hasNextPage:
              pagination.hasNextPage ??
              false,

            hasPreviousPage:
              pagination.hasPreviousPage ??
              false,
          };

          state.usersCount =
            Number(
              pagination.totalUsers
            ) || users.length;
        }
      )

      .addCase(
        getUsers.rejected,
        (state, action) => {

          state.usersLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch users";

          state.users = [];

          state.usersCount = 0;

          state.usersPagination = {

            totalUsers: 0,

            currentPage: 1,

            limit: 10,

            totalPages: 0,

            hasNextPage: false,

            hasPreviousPage: false,
          };
        }
      );

    /* =====================================================
       GET QR
    ===================================================== */

    builder

      .addCase(
        getQr.pending,
        (state) => {

          state.qrLoading = true;

          state.error = null;
        }
      )

      .addCase(
        getQr.fulfilled,
        (state, action) => {

          state.qrLoading = false;

          state.error = null;

          state.qr =
            action.payload?.data ||
            null;
        }
      )

      .addCase(
        getQr.rejected,
        (state, action) => {

          state.qrLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch QR";
        }
      );

    /* =====================================================
       EDIT QR
    ===================================================== */

    builder

      .addCase(
        editQr.pending,
        (state) => {

          state.qrUpdateLoading = true;

          state.error = null;
        }
      )

      .addCase(
        editQr.fulfilled,
        (state, action) => {

          state.qrUpdateLoading = false;

          state.error = null;

          state.qr =
            action.payload?.data ||
            state.qr;
        }
      )

      .addCase(
        editQr.rejected,
        (state, action) => {

          state.qrUpdateLoading = false;

          state.error =
            action.payload ||
            "Failed to update QR";
        }
      );

    /* =====================================================
       UPDATE PROFILE
    ===================================================== */

    builder

      .addCase(
        updateProfile.pending,
        (state) => {

          state.loading = true;

          state.error = null;

          state.updateSuccess = false;
        }
      )

      .addCase(
        updateProfile.fulfilled,
        (state, action) => {

          state.loading = false;

          state.updateSuccess = true;

          state.error = null;

          state.profilelist = {

            ...state.profilelist,

            ...(action.payload?.data || {}),
          };
        }
      )

      .addCase(
        updateProfile.rejected,
        (state, action) => {

          state.loading = false;

          state.error =
            action.payload ||
            "Failed to update profile";

          state.updateSuccess = false;
        }
      );

    /* =====================================================
       CHANGE PASSWORD
    ===================================================== */

    builder

      .addCase(
        changePassword.pending,
        (state) => {

          state.changePasswordLoading = true;

          state.changePasswordSuccess = false;

          state.changePasswordError = null;
        }
      )

      .addCase(
        changePassword.fulfilled,
        (state) => {

          state.changePasswordLoading = false;

          state.changePasswordSuccess = true;

          state.changePasswordError = null;
        }
      )

      .addCase(
        changePassword.rejected,
        (state, action) => {

          state.changePasswordLoading = false;

          state.changePasswordSuccess = false;

          state.changePasswordError =
            action.payload ||
            "Failed to change password.";
        }
      );
  },
});

/* =========================================================
   ACTIONS
========================================================= */

export const {
  resetUpdateStatus,
  resetJoiningPaymentAction,
  clearProfileError,
  resetChangePassword,
} = profileSlice.actions;

/* =========================================================
   REDUCER
========================================================= */

export default profileSlice.reducer;